<template>
  <div class="system">
    <p class="big-title">{{ $t('ourWay') }}</p>
    <!-- <div class="flow">
      <ul class="flow-list">
        <li class="step1">
          <p class="title">1，{{ $t('step1') }}</p>
          <p class="desc">{{ $t('desc1') }}</p>
        </li>
        <li class="step2">
          <p class="title">2，{{ $t('step2') }}</p>
          <p class="desc">{{ $t('desc2') }}</p>
        </li>
        <li class="step3">
          <p class="title">3，{{ $t('step3') }}</p>
          <p class="desc">{{ $t('desc3') }}</p>
        </li>
        <li class="step4">
          <p class="title">4，{{ $t('step4') }}</p>
          <p class="desc">{{ $t('desc4') }}</p>
        </li>
        <li class="step5">
          <p class="title">5，{{ $t('step5') }}</p>
          <p class="desc">{{ $t('desc5') }}</p>
        </li>
      </ul>
    </div> -->
    <div class="system-img">
      <img v-if="$i18n.locale === 'en'" src="../assets/system-en.png" alt="" />
      <img v-if="$i18n.locale === 'cn'" src="../assets/system-cn.png" alt="" />
      <img v-if="$i18n.locale === 'TW'" src="../assets/system-tw.png" alt="" />
    </div>
    <platform></platform>
  </div>
</template>
<script>
import platform from '@/components/Platform.vue'
export default {
  components: { platform },
}
</script>
<style lang="scss" scoped>
.big-title {
  padding: 77px 0 0;
  font-size: 36px;
  color: #002147;
  text-align: center;
  line-height: 47px;
  width: 1120px;
  padding-bottom: 23px;
  margin: 0 auto;
  border-bottom: 1px solid #dbdbdb;
}
.banner {
  height: 500px;
  background: url(../assets/demo/banner.jpg) no-repeat center center;
}
.standard {
  height: 890px;
  background: #fff;
  padding: 75px 0 190px;
  .title {
    font-size: 32px;
    text-align: center;
    line-height: 42px;
  }
}
.grade {
  width: 375px;
  overflow: hidden;
  margin: 0 auto;
  li {
    padding: 0 10px;
    width: 125px;
    text-align: center;
    float: left;
    cursor: pointer;
    .txt {
      display: inline-block;
      padding: 30px 0;
      line-height: 19px;
    }
    &.on .txt {
      border-bottom: 2px solid #002147;
    }
  }
}
.subject {
  margin: 42px auto 50px;
  width: 1200px;
  text-align: center;
  li {
    display: inline-block;
    min-width: 112px;
    height: 36px;
    border: 1px solid transparent;
    line-height: 34px;
    cursor: pointer;
    &.on {
      border-color: #707070;
    }
  }
}
.step {
  width: 1200px;
  margin: 0 auto;
  overflow: hidden;
  li {
    float: left;
    width: 220px;
    margin: 0 10px;
    &:nth-child(1) {
      padding-top: 200px;
      .desc {
        background: #002147;
        height: 124px;
      }
    }
    &:nth-child(2) {
      padding-top: 150px;
      .desc {
        background: #a9c4b1;
        height: 174px;
      }
    }
    &:nth-child(3) {
      padding-top: 100px;
      .desc {
        background: #00b9ff;
        height: 224px;
      }
    }
    &:nth-child(4) {
      padding-top: 50px;
      .desc {
        background: #ff9b04;
        height: 274px;
      }
    }
    &:nth-child(5) {
      .desc {
        background: #ff0000;
        height: 324px;
      }
    }
  }
  .topic {
    line-height: 42px;
    font-size: 32px;
    font-weight: bold;
    margin-bottom: 20px;
    text-align: center;
  }
  .desc {
    padding: 20px;
    font-size: 16px;
    color: #fff;
    border-radius: 12px;
    &:after {
      content: '';
      height: 100%;
      display: inline-block;
      vertical-align: middle;
    }
  }
  .text {
    display: inline-block;
    max-height: 100%;
    overflow: hidden;
    vertical-align: middle;
  }
}
.flow {
  padding-top: 100px;
  height: 830px;
}
.flow-list {
  position: relative;
  width: 898px;
  height: 500px;
  background: url(../assets/flow4.png);
  transform: scale(1.2);
  margin: 0 auto;
  li {
    position: absolute;
    width: 222px;
    &.step1,
    &.step2 {
      top: 160px;
    }
    &.step3,
    &.step4 {
      top: 410px;
    }
    &.step1 {
      left: 50px;
    }
    &.step2 {
      left: 623px;
    }
    &.step3 {
      left: 623px;
    }
    &.step4 {
      left: 117px;
    }
    &.step5 {
      left: 356px;
      top: 288px;
    }
  }
  .title {
    font-weight: bold;
    color: #99b4a1;
  }
  .desc {
    margin-top: 14px;
    line-height: 1.2;
    color: #0f2241;
    font-size: 12px;
  }
}
.system-img {
  width: 900px;
  text-align: center;
  margin: 60px auto;
  img {
    width: 100%;
    height: auto;
  }
}
</style>
<style lang="scss" scoped>
@media screen and (max-width: 768px) {
  .big-title {
    width: 100%;
    font-size:8vw;
    line-height: normal;
    padding: 10px 0;
    // padding-bottom: 0;
  }
  .system-img {
    margin: 0;
    width: 100%;
  }
  .platform{
    padding: 0;
  }
  .platform-list{
    margin: 0;
  }
}
</style>
<i18n>
{
  "cn": {
    "ourWay":"课程体系",
    "step1": "学前评估",
    "step2": "学习方案规划",
    "step3": "目标性导学",
    "step4": "学情反馈",
    "step5": "达成目标",
    "desc1": "正式上课前，会进行学前评估，诊断可让老师更清楚学生的学习状况及其物质，并快速找到学生的差异和不足，从问题的根本出发。",
    "desc2": "根据每个学生的特点及要求，制定针对性的学习方案，协助学生达成学习目标。",
    "desc3": "设定学习目标，配以我们的高效学习方法，助你达成目标。",
    "desc4": "老师的专业课程和跟进，有效提升学习成果。",
    "desc5": "我们的老师拥有超卓的学术成就，带领你学习宝贵知识，助你实现学习目标和理想。"
  },
  "TW": {
    "ourWay":"課程體系",
    "step1": "學前評估",
    "step2": "學習方案規劃",
    "step3": "目標性導學",
    "step4": "學情迴響",
    "step5": "達成目標",
    "desc1": "正式上課前，會進行學前評估，診斷可讓老師更清楚學生的學習狀況及其物質，並快速找到學生的差异和不足，從問題的根本出發。",
    "desc2": "根據每個學生的特點及要求，製定針對性的學習方案，協助學生達成學習目標。",
    "desc3": "設定學習目標，配以我們的高效學習方法，助你達成目標",
    "desc4": "老師的專業課程和跟進，有效提升學習成果",
    "desc5": "我們的老師擁有超卓的學術成就，帶領你學習寶貴知識，助你實現學習目標和理想。"
  },
  "en": {
    "ourWay":"OUR WAY",
    "step1": "PRELIMINARY ASSESSMENT",
    "step2": "STRATEGIC PLANNING ",
    "step3": "TARGETED LEARNING ",
    "step4": "TUTOR FEEDBACK ",
    "step5": "ACHIEVE YOUR GOALS ",
    "desc1": "Preliminary assessments allow Tutors to understand more about each Student's academic standard and personal characteristics; Tutors can quickly identify problems that need to be addressed. ",
    "desc2": "Tutors devise targeted learning programmes to help students achieve their goals and objectives.",
    "desc3": "Set yourself a goal, and allow us to help you reach it. ",
    "desc4": "Monthly Tutor reports ensure the student is on the right track. ",
    "desc5": "Tap into the wealth of unrivalled academic brilliance that our Tutors offer,and you are on your way to achieving your academic goals."
  }
}
</i18n>